$(function() {
    if ($('body').hasClass('home')) {
        $(window).on('scroll', function () {
            const $section = $('#hvideo-section');
            const rect = $section[0].getBoundingClientRect();
            const midpoint = window.innerHeight / 2.8;

            if (rect.top < midpoint && rect.bottom > midpoint) {
                $section.addClass('expand');
            }
            if (rect.bottom <= 0) {
                $section.removeClass('expand');
            }
            if (window.scrollY === 0) {
                $section.removeClass('expand');
            }
        });
    }

    $("#btnplay").on("click", function () {
        var vid = $('#hvideo').get(0);
        if (vid.paused) {
            vid.play();
            $('#btnplay').html('<i class="fa-solid fa-pause pause"></i>');
        } else {
            vid.pause();
            $('#btnplay').html('<i class="fa-solid fa-play play"></i>');
        }
    });

    $("#btnmute").on("click", function () {
        const video = document.getElementById('hvideo');
        video.muted = !video.muted;
        if (video.muted) {
            $('#btnmute i').removeClass("fa-volume-xmark").addClass("fa-volume-high");
        } else {
            $('#btnmute i').removeClass("fa-volume-high").addClass("fa-volume-xmark");
        }
    });

    // Vimeo home page video
    const $vimeo = $('#vimeoPlayer');
    if ($vimeo.length) {
        const player = new Vimeo.Player($('#vimeoPlayer')[0]);
        let isPlaying = true;
        let isMuted = true;
        $('#playbtn').on('click', function () {
            if (isPlaying) {
                player.pause();
                $('#playbtn').html('<i class="fa-solid fa-play"></i>');
                isPlaying = false;
            } else {
                player.play();
                $('#playbtn').html('<i class="fa-solid fa-pause"></i>');
                isPlaying = true;
            }
        });
        $('#mutebtn').on('click', function () {
            if (isMuted) {
                player.setVolume(1);
                $('#mutebtn').html('<i class="fa-solid fa-volume-high"></i>');
                isMuted = false;
            } else {
                player.setVolume(0);
                $('#mutebtn').html('<i class="fa-solid fa-volume-xmark"></i>');
                isMuted = true;
            }
        });
    }

});
